import axios from 'axios';
const auth_backend = process.env.REACT_APP_PORT_8001;
const google_redirect_uri = process.env.REACT_APP_GOOGLE_REDIRECT_URI;

export const googleCallback = async (code) => {
  try {
    const response = await axios.post(`${auth_backend}google-callback/?redirect_uri=${google_redirect_uri}`, { code });
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};